<script>
import InputDays from '../__components/Days.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    InputDays,
  },
  props: {
    value: {
      type: Array,
    },
  },
  mounted() {
    this.$emit('fixed-label', true);
  },
};
</script>
<template>
  <InputDays
    :value="value"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
